// extracted by mini-css-extract-plugin
module.exports = {"root":"_28S6S","bg":"rWG2G","content":"VApRZ"};